import { RootState } from "../../modules";

// Selectors
export const selectors = {
  getDeleteFileState: (state: RootState) => {
    return state.upload.deleteFile;
  },
};
